import { render, staticRenderFns } from "./icon-media.vue?vue&type=template&id=4d06a59a&"
import script from "./icon-media.vue?vue&type=script&lang=js&"
export * from "./icon-media.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports